// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import Tab from '@mui/material/Tab'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList';
import {
    Divider,
    IconButton,
    Fab,
    Autocomplete,
    FormControlLabel,
    Checkbox,
    OutlinedInput,
    InputAdornment,
    Tooltip,
} from '@mui/material'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'

import { data, useParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import React from 'react';
import { useToast } from '../../../../components/ToastProvider';

export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const { id } = useParams();
    const { showToast, hideToast } = useToast();

    // ** State
    const [valModel, setValModel] = useState<any>(null)
    const [listModel, setListModel] = useState<any[]>([])
    const [listData, setListData] = useState<any[]>([])

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])
    const [listItem, setListItem] = useState<any[]>([])
    const [valItem, setValItem] = useState<any>(null)
    const [valJasa, setValJasa] = useState<any>(null)
    const [listBarangJasa, setListBarangJasa] = useState<any[]>([])

    const [listJenisModel, setListJenisModel] = useState<any[]>([])
    const [tabs, setTabs] = useState<string>('1')

    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [openDialogJasa, setOpenDialogJasa] = useState<boolean>(false)
    const [isEdit, setIsEdit] = useState<boolean>(false)

    const [listBagian, setListBagian] = useState<any[]>([])
    const [listBagianDetail, setListBagianDetail] = useState<any[]>([])
    const [file, setFile] = useState<any>(null)
    const [txtFile, setTxtFile] = useState<string>('Pilih File')

    useEffect(() => {
        getData()
        getBarangJasa()
        getListItem(0);
    }, [])

    const getDoctag = (ids: any) => {
        const url = apiUrl.apiUrl + '/system/doctag/list-combo'
        axios
            .get(url, {
                params: { sysmenu_id: 47 },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id === ids) {
                            setValDoctag(element)
                        }
                    });
                    setListDoctag(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getModel = (ids: any) => {
        const url = apiUrl.apiUrl + '/sales/model/list-combo/'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id === ids) {
                            setValModel(element)
                        }
                    });
                    setListModel(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getListJenis = () => {
        const url = apiUrl.apiUrl + '/sales/model/list-jenis-model'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListJenisModel(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        getListData(newValue);
    }

    const hiddenFileInput = React.useRef<HTMLInputElement>(null)
    const handleClick = (event: any) => {
        if (hiddenFileInput.current) {
            hiddenFileInput.current.click()
        }
    }
    const handleFile = async (event: any) => {
        const files = event.target.files[0]
        const nameFiles = files.name
        // const image = await resizeFile(files)
        setFile(files)
        setTxtFile(nameFiles)
        setValue('image', files)
    }

    const getData = () => {
        const url = apiUrl.apiUrl + '/sales/model/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setValue('nama_model', data.nama_model)
                    setValue('tinggi', data.tinggi)
                    setValue('panjang', data.panjang)
                    setValue('lebar', data.lebar)
                    setValue('keterangan', data.keterangan)
                    setValue('kode', data.kode)
                    setValue('jenis_model', data.jenis_model)
                    setValue('sysdoctag_id', data.sysdoctag_id)
                    setValue('sdmodel_id', data.sdmodel_id)
                    setValue('link', data.link)

                    getListJenis()
                    getModel(data.sdmodel_id)
                    getDoctag(data.sysdoctag_id)

                    getListBagian()
                    getListData(tabs)

                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }
    const getListData = (tabs: any) => {
        const url = apiUrl.apiUrl + '/sales/model/list-model-detail/' + id
        axios
            .get(url, {
                params: { tabs: tabs },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getBarangJasa = () => {
        const url = apiUrl.apiUrl + '/sales/model/list-barang-jasa/'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListBarangJasa(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getListBagian = () => {
        const url = apiUrl.apiUrl + '/sales/model/list-bagian'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    setListBagian(response.data.data)
                    setListBagianDetail(response.data.detail)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getListBagianDetail = (bagian: any) => {
        const url = apiUrl.apiUrl + '/sales/model/list-bagian-detail/' + bagian
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListBagianDetail(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getListItem = (jenisBarangId: number) => {
        let isKain = getValues('is_kain') || 1;
        const url = apiUrl.apiUrl + '/sales/model/list-item/' + isKain
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListItem(data)
                    data.forEach((element: any) => {
                        if (element.id === jenisBarangId) {
                            setValItem(element)
                        }
                    });
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const ActionButtons = ({ row, onDelete }: {
        row: any;
        onDelete: (row: any) => void;
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:pencil",
                color: "primary",
                onClick: () => { handleEdit(row) }
            },
            {
                title: "Hapus Data",
                icon: "mdi:trash",
                color: "primary",
                onClick: () => onDelete(row)
            }
        ];

        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const handleEdit = (row: any) => {
        console.log('edit row', row);
        if (row.is_jasa == 1) {
            setOpenDialogJasa(true);
            resetForm();
            setIsEdit(true);
            setValue('sdmodel_d_id', row.id);
            setValue('jenis_barang_id', row.jenis_barang_id);
            setValue('qty_bagian', row.qty);
            setValue('keterangan_bagian', row.keterangan);
            setValue('jasa_id', row.jenis_barang_id);
            setValue('biaya_produksi', row.biaya_jasa);
            listBarangJasa.forEach(element => {
                if (element.id == row.jenis_barang_id) {
                    setValJasa(element);
                }
            });
        } else {
            setOpenDialog(true);
            resetForm();
            setIsEdit(true);
            setValue('sdmodel_d_id', row.id);
            setValue('is_kain', row.is_kain);
            setValue('bagian', row.jenis_bagian);
            getListBagianDetail(row.jenis_bagian);
            getListItem(row.jenis_barang_id);
            setValue('detail_bagian', row.detail_bagian);
            setValue('jenis_barang_id', row.jenis_barang_id);
            setValue('is_berubah_panjang', row.is_berubah_panjang);
            setValue('persen_lebih_panjang_panjang', row[`%_panjang`]);
            setValue('persen_lebih_panjang_lebar', row[`%_lebar`]);
            setValue('is_berubah_lebar', row.is_berubah_lebar);
            setValue('persen_lebih_lebar_panjang', row[`%__panjang`]);
            setValue('persen_lebih_lebar_lebar', row[`%__lebar`]);
            setValue('is_berubah_tinggi', row.is_berubah_tinggi);
            setValue('persen_lebih_tinggi_panjang', row[`%___panjang`]);
            setValue('persen_lebih_tinggi_lebar', row[`%___lebar`]);
            setValue('is_biaya_produksi', row.is_biaya_produksi);
            setValue('jasa_id', row.jasa_id);
            setValue('biaya_produksi', row.biaya_jasa);
            listBarangJasa.forEach(element => {
                if (element.id == row.jasa_id) {
                    setValJasa(element);
                }
            });

            setValue('keterangan_bagian', row.keterangan);
            if (row.is_kain == 0) {
                setValue('qty_bagian', row.qty);
            } else {
                setValue('kebutuhan_bagian', row.kebutuhan);
                setValue('panjang_bagian', row.panjang);
                setValue('lebar_bagian', row.lebar);
                setValue('lebihan_panjang_bagian', row.lebihan_panjang);
                setValue('lebihan_lebar_bagian', row.lebihan_lebar);
            }
        }
    };

    const handleDelete = (row: any) => {
        const url = apiUrl.apiUrl + '/sales/model/delete-detail/' + row.id
        axios
            .delete(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    getListData(tabs);
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                />
            ),
        },
    ];


    const resetForm = () => {
        setValue('bagian', '');
        setValue('detail_bagian', '');
        setValue('kebutuhan_bagian', 1);
        setValue('panjang_bagian', 0);
        setValue('lebar_bagian', 0);
        setValue('tinggi_bagian', 0);
        setValue('lebihan_panjang_bagian', 0);
        setValue('lebihan_lebar_bagian', 0);
        setValue('keterangan_bagian', '');
        setValue('qty_bagian', '');
        setValItem(null);
        setValue('is_berubah_panjang', false);
        setValue('is_berubah_lebar', false);
        setValue('is_berubah_tinggi', false);
        setValue('persen_lebih_panjang_panjang', 0);
        setValue('persen_lebih_lebar_panjang', 0);
        setValue('persen_lebih_tinggi_panjang', 0);
        setValue('persen_lebih_panjang_lebar', 0);
        setValue('persen_lebih_lebar_lebar', 0);
        setValue('persen_lebih_tinggi_lebar', 0);
        setValue('jenis_barang_id', '');
        setValue('sdmodel_d_id', '');
        setValue('is_biaya_produksi', 0);
        setValue('biaya_produksi', null);
        setValue('jasa_id', null);
        setValJasa(null);
    }
    const openModelItem = () => {
        resetForm();
        setOpenDialog(true)
        getListItem(0);
    }

    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        sdmodel_id: any,
        kode: any,
        jenis_model: any,
        nama_model: any,
        keterangan: any,
        panjang: any,
        lebar: any,
        tinggi: any,
        image: any,
        link: any,
        bagian: string,
        detail_bagian: string,
        kebutuhan_bagian: number,
        panjang_bagian: number,
        lebar_bagian: number,
        tinggi_bagian: number,
        lebihan_panjang_bagian: number,
        lebihan_lebar_bagian: number,
        keterangan_bagian: string,
        is_kain: any,
        qty_bagian: any,
        jenis_barang_id: any,
        is_berubah_panjang: any,
        is_berubah_lebar: any,
        is_berubah_tinggi: any,
        persen_lebih_panjang_panjang: any,
        persen_lebih_panjang_lebar: any,
        persen_lebih_lebar_panjang: any,
        persen_lebih_lebar_lebar: any,
        persen_lebih_tinggi_panjang: any,
        persen_lebih_tinggi_lebar: any,
        sdmodel_d_id: any,
        is_biaya_produksi: any,
        biaya_produksi: any,
        jasa_id: any,
    }

    const defaultValues = {
        syscabang_id: cabang
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        watch,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue?.id)
        setValDoctag(newValue)
    }

    const handleChangeAutocompleteItem = (event: SyntheticEvent, newValue: any | null) => {
        setValue('jenis_barang_id', newValue?.id)
        setValItem(newValue)
    }

    const handleChangeAutocompleteJasa = (event: SyntheticEvent, newValue: any | null) => {
        setValue('jasa_id', newValue?.id)
        setValue('biaya_produksi', newValue?.harga || 0)
        setValJasa(newValue)
    }

    const handleChangeAutocompleteModel = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sdmodel_id', newValue?.id)
        setValModel(newValue)
    }

    // const formRender = [
    //     {
    //         key: "jenis_bagian",
    //         editorType: "select",
    //         items: listBagian,
    //         displayExpr: "nama",
    //         valueExpr: "id",
    //         child: "detail_bagian",
    //     },
    //     {
    //         key: "detail_bagian",
    //         editorType: "select",
    //         items: listBagianDetail,
    //         displayExpr: "nama",
    //         valueExpr: "id",
    //         filterBy: "jenis_bagian",
    //     },
    //     {
    //         key: "jenis_barang",
    //         editorType: "select",
    //         items: listItem,
    //         displayExpr: "nama",
    //         valueExpr: "id",
    //     },
    //     {
    //         key: "jasa",
    //         editorType: "select",
    //         items: listBarangJasa,
    //         displayExpr: "nama",
    //         valueExpr: "id",
    //     },
    //     {
    //         key: "is_berubah_panjang",
    //         editorType: "checkbox",
    //     },
    //     {
    //         key: "is_berubah_panjang",
    //         editorType: "checkbox",
    //     },
    //     {
    //         key: "is_berubah_lebar",
    //         editorType: "checkbox",
    //     },
    //     {
    //         key: "is_berubah_tinggi",
    //         editorType: "checkbox",
    //     },
    //     {
    //         key: "biaya",
    //         editorType: "number",
    //     },
    // ];

    const onSubmit = (data: any) => {
        const url = apiUrl.apiUrl + '/sales/model/edit/' + id
        const formData = new FormData();
        formData.append("kode", data.kode);
        formData.append("jenis_model", data.jenis_model);
        formData.append("nama_model", data.nama_model);
        formData.append("keterangan", data.keterangan);
        formData.append("panjang", data.panjang);
        formData.append("lebar", data.lebar);
        formData.append("tinggi", data.tinggi);
        formData.append("image", file);

        axios.post(url, formData, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    window.location.reload();
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    }

    const convertComponent = [
        {
            key: "is_berubah_panjang",
            renderCell: (row: any) => {
                return row.data.is_berubah_panjang === 1 ? (
                    <FormControlLabel
                        label=''
                        control={<Checkbox checked={true} readOnly />}
                    />
                ) : (
                    ""
                );
            },
        },
        {
            key: "is_berubah_lebar",
            renderCell: (row: any) => {
                return row.data.is_berubah_lebar === 1 ? (
                    <FormControlLabel
                        label=''
                        control={<Checkbox checked={true} readOnly />}
                    />
                ) : (
                    ""
                );
            },
        },
        {
            key: "is_biaya_produksi",
            renderCell: (row: any) => {
                return row.data.is_biaya_produksi === 1 ? (
                    <FormControlLabel
                        label=''
                        control={<Checkbox checked={true} readOnly />}
                    />
                ) : (
                    ""
                );
            },
        },
        {
            key: "is_berubah_tinggi",
            renderCell: (row: any) => {
                return row.data.is_berubah_tinggi === 1 ? (
                    <FormControlLabel
                        label=''
                        control={<Checkbox checked={true} readOnly />}
                    />
                ) : (
                    ""
                );
            },
        },
        {
            key: "%_panjang",
            renderCell: (row: any) => {
                const raw = row.data['%_panjang'] ?? '';
                if (raw === null || raw === undefined || raw === '') return '';
                const num = Number(raw);
                const display = !isNaN(num) ? `${num}%` : (String(raw).toString().trim().endsWith('%') ? String(raw) : `${String(raw)}%`);
                return <>{display}</>;
            },
        },
        {
            key: "%_lebar",
            renderCell: (row: any) => {
                const raw = row.data['%_lebar'] ?? '';
                if (raw === null || raw === undefined || raw === '') return '';
                const num = Number(raw);
                const display = !isNaN(num) ? `${num}%` : (String(raw).toString().trim().endsWith('%') ? String(raw) : `${String(raw)}%`);
                return <>{display}</>;
            },
        },
        {
            key: "%__panjang",
            renderCell: (row: any) => {
                const raw = row.data['%__panjang'] ?? '';
                if (raw === null || raw === undefined || raw === '') return '';
                const num = Number(raw);
                const display = !isNaN(num) ? `${num}%` : (String(raw).toString().trim().endsWith('%') ? String(raw) : `${String(raw)}%`);
                return <>{display}</>;
            },
        },
        {
            key: "%__lebar",
            renderCell: (row: any) => {
                const raw = row.data['%__lebar'] ?? '';
                if (raw === null || raw === undefined || raw === '') return '';
                const num = Number(raw);
                const display = !isNaN(num) ? `${num}%` : (String(raw).toString().trim().endsWith('%') ? String(raw) : `${String(raw)}%`);
                return <>{display}</>;
            },
        },
        {
            key: "%___panjang",
            renderCell: (row: any) => {
                const raw = row.data['%___panjang'] ?? '';
                if (raw === null || raw === undefined || raw === '') return '';
                const num = Number(raw);
                const display = !isNaN(num) ? `${num}%` : (String(raw).toString().trim().endsWith('%') ? String(raw) : `${String(raw)}%`);
                return <>{display}</>;
            },
        },
        {
            key: "%___lebar",
            renderCell: (row: any) => {
                const raw = row.data['%___lebar'] ?? '';
                if (raw === null || raw === undefined || raw === '') return '';
                const num = Number(raw);
                const display = !isNaN(num) ? `${num}%` : (String(raw).toString().trim().endsWith('%') ? String(raw) : `${String(raw)}%`);
                return <>{display}</>;
            },
        }
    ];

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Model
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <br />
                    <Divider sx={{ mb: 3 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='sysdoctag_id'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valDoctag}
                                                options={listDoctag}
                                                id='sysdoctag_id'
                                                readOnly
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteDoctag}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Document Tag'
                                                        error={Boolean(errors.sysdoctag_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.sysdoctag_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel>Jenis Model</InputLabel>
                                    <Controller
                                        name='jenis_model'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Jenis Model'
                                                value={value || ''}
                                                onChange={onChange}
                                                error={Boolean(errors.jenis_model)}
                                                readOnly
                                            >
                                                {listJenisModel.map((item: any, index: any) => (
                                                    <MenuItem value={item.nama} key={index}>
                                                        {item.nama}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.jenis_model && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='sdmodel_id'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valModel}
                                                options={listModel}
                                                id='sdmodel_id'
                                                readOnly
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteModel}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Model'
                                                        error={Boolean(errors.sdmodel_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.sdmodel_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nama_model'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Model'
                                                error={Boolean(errors.nama_model)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.nama_model && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kode'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Kode Model'
                                                error={Boolean(errors.kode)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.kode && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='panjang'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Panjang'
                                                type='number'
                                                error={Boolean(errors.panjang)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.panjang && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='lebar'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Lebar'
                                                type='number'
                                                error={Boolean(errors.lebar)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.lebar && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tinggi'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Tinggi'
                                                type='number'
                                                error={Boolean(errors.tinggi)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.tinggi && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <input
                                    type='file'
                                    ref={hiddenFileInput}
                                    onChange={handleFile}
                                    style={{ display: 'none' }}
                                    accept='image/png, image/jpg, image/jpeg'
                                ></input>
                                <FormControl fullWidth>
                                    <Controller
                                        name='image'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <>
                                                <InputLabel htmlFor='input-file'>Gambar</InputLabel>
                                                <OutlinedInput
                                                    label='Foto'
                                                    value={txtFile}
                                                    id='input-file'
                                                    type={'text'}
                                                    error={Boolean(errors.image)}
                                                    startAdornment={
                                                        <Box
                                                            onClick={handleClick}
                                                            onMouseDown={e => e.preventDefault()}
                                                            sx={{ cursor: 'pointer' }}
                                                        >
                                                            <InputAdornment position='start'>
                                                                Ubah Gambar &nbsp;
                                                                <IconButton edge='start' aria-label='paperclip'>
                                                                    <Icon fontSize={20} icon={'mdi:paperclip'} />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        </Box>
                                                    }
                                                />
                                            </>
                                        )}
                                    />
                                    {errors.image && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    sx={{ mt: 1 }}
                                    disabled={!getValues('link')}
                                    onClick={() => {
                                        if (!getValues('link')) return;
                                        Swal.fire({
                                            title: 'Gambar Model',
                                            imageUrl: getValues('link'),
                                            imageAlt: 'Gambar Model',
                                            showCloseButton: true,
                                            showConfirmButton: false,
                                            width: 600,
                                            padding: '1em'
                                        });
                                    }}
                                >
                                    Lihat Gambar
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Keterangan'
                                                rows={2}
                                                multiline
                                                error={Boolean(errors.keterangan)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} sx={{ marginBottom: 3 }}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                    <Divider sx={{ m: 0 }} />
                    <Box sx={{ mt: 4 }}>
                        <TabContext value={tabs}>
                            <TabList scrollButtons variant='scrollable' onChange={handleChangeTabs} aria-label='customized tabs example'>
                                <Tab value='1' label='ITEM KAIN' />
                                <Tab value='2' label='ITEM BUKAN KAIN' />
                                <Tab value='3' label='LIST JASA' />
                            </TabList>
                            <TabPanel value='1'>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                                    <Button variant="contained" color="primary" onClick={() => { setValue('is_kain', 1); openModelItem(); setIsEdit(false); }}>
                                        Tambah Kain
                                    </Button>
                                </Box>
                                <Typography variant="h6" sx={{ mb: 2 }}>
                                    LIST ITEM KAIN
                                </Typography>
                                <Box sx={{ overflowX: 'auto' }}>
                                    {/* <MsiDatagrid onDelete={handleDelete} onEdit={handleEdit} allowRowEdit={true} allowRowDelete={true} allowRowRevert={true} formRender={formRender} allowEditing={true} allowNewRecord={true} key={1} array={listData} customRender={convertComponent} hiddenColumns={['is_kain','id','jenis_barang_id','is_jasa','harga_jual','jasa_id','is_biaya_produksi']}  /> */}
                                    <MsiDatagrid key={1} array={listData} customRender={convertComponent} hiddenColumns={['is_kain', 'id', 'jenis_barang_id', 'is_jasa', 'harga_jual', 'jasa_id', 'is_biaya_produksi']} actions={actionData} />
                                </Box>
                            </TabPanel>
                            <TabPanel value='2'>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                                    <Button variant="contained" color="primary" onClick={() => { setValue('is_kain', 0); openModelItem(); setIsEdit(false); }}>
                                        Tambah Bukan Kain
                                    </Button>
                                </Box>
                                <Typography variant="h6" sx={{ mb: 2 }}>
                                    LIST ITEM BUKAN KAIN
                                </Typography>
                                <Box sx={{ overflowX: 'auto' }}>
                                    <MsiDatagrid key={1} array={listData} customRender={convertComponent} hiddenColumns={['is_kain', 'id', 'jenis_barang_id', 'is_jasa', 'harga_jual', 'jasa_id', 'is_biaya_produksi']} actions={actionData} />
                                </Box>
                            </TabPanel>
                            <TabPanel value='3'>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                                    <Button variant="contained" color="primary"
                                        onClick={() => {
                                            resetForm();
                                            setOpenDialogJasa(true);
                                            setIsEdit(false);
                                        }}>
                                        Tambah Jasa
                                    </Button>
                                </Box>
                                <Typography variant="h6" sx={{ mb: 2 }}>
                                    LIST DETAIL JASA
                                </Typography>
                                <Box sx={{ overflowX: 'auto' }}>
                                    <MsiDatagrid key={1} array={listData} customRender={convertComponent} hiddenColumns={['is_kain', 'id', 'jenis_barang_id', 'is_jasa', '%_panjang', '%_lebar', '%__panjang', '%__lebar', '%___panjang', '%___lebar', 'is_berubah_panjang', 'is_berubah_lebar', 'is_berubah_tinggi', 'is_biaya_produksi']} actions={actionData} />
                                </Box>
                            </TabPanel>
                        </TabContext>
                    </Box>
                </div>
            </Grid>

            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    const formData = {
                        sdmodel_id: id,
                        jenis_bagian: getValues('bagian'),
                        detail_bagian: getValues('detail_bagian'),
                        kebutuhan: getValues('kebutuhan_bagian'),
                        panjang: getValues('panjang_bagian'),
                        lebar: getValues('lebar_bagian'),
                        lebihan_panjang: getValues('lebihan_panjang_bagian'),
                        lebihan_lebar: getValues('lebihan_lebar_bagian'),
                        keterangan: getValues('keterangan_bagian'),
                        qty: getValues('qty_bagian'),
                        is_kain: getValues('is_kain'),
                        jenis_barang_id: getValues('jenis_barang_id'),
                        is_berubah_panjang: getValues('is_berubah_panjang') ? 1 : 0,
                        is_berubah_lebar: getValues('is_berubah_lebar') ? 1 : 0,
                        is_berubah_tinggi: getValues('is_berubah_tinggi') ? 1 : 0,
                        persen_lebih_panjang_panjang: getValues('persen_lebih_panjang_panjang'),
                        persen_lebih_lebar_panjang: getValues('persen_lebih_lebar_panjang'),
                        persen_lebih_tinggi_panjang: getValues('persen_lebih_tinggi_panjang'),
                        persen_lebih_panjang_lebar: getValues('persen_lebih_panjang_lebar'),
                        persen_lebih_lebar_lebar: getValues('persen_lebih_lebar_lebar'),
                        persen_lebih_tinggi_lebar: getValues('persen_lebih_tinggi_lebar'),
                        is_biaya_produksi: getValues('is_biaya_produksi') ? 1 : 0,
                        biaya_produksi: getValues('biaya_produksi') || 0,
                        jasa_id: getValues('jasa_id') || null,
                    }

                    let url = apiUrl.apiUrl + '/sales/model/add-detail'
                    if (isEdit) {
                        url = apiUrl.apiUrl + '/sales/model/edit-detail/' + getValues('sdmodel_d_id');
                    }
                    axios
                        .post(url, formData, {
                            headers: { Authorization: `Bearer ${token}` }
                        })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                getListData(tabs)
                                setOpenDialog(false);
                            } else {
                                showToast(response.data.message, 'error');
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        })
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Tambah Item
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            {isEdit && (
                                <Grid item xs={12} sm={12}>
                                    <FormControl fullWidth>
                                        <Controller
                                            name='sdmodel_d_id'
                                            control={control}
                                            rules={{ required: true }}
                                            render={({ field: { value, onChange } }) => (
                                                <TextField
                                                    label='ID'
                                                    error={Boolean(errors.sdmodel_d_id)}
                                                    onChange={onChange}
                                                    type='number'
                                                    value={value}
                                                    InputLabelProps={{ shrink: true }}
                                                    InputProps={{ readOnly: true }}
                                                />
                                            )}
                                        />
                                        {errors.sdmodel_d_id && (
                                            <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                            )}
                            <Grid item xs={12} sm={5}>
                                <FormControl fullWidth>
                                    <InputLabel>Bagian</InputLabel>
                                    <Controller
                                        name='bagian'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Bagian'
                                                value={value || ''}
                                                onChange={e => {
                                                    onChange(e);
                                                    setValue('bagian', e.target.value);
                                                    getListBagianDetail(e.target.value);
                                                }}
                                                error={Boolean(errors.bagian)}
                                            >
                                                {listBagian.map((item: any, index: any) => (
                                                    <MenuItem value={item.nama} key={index}>
                                                        {item.nama}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.bagian && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={1} sx={{ display: "flex", alignItems: "center" }}>
                                <IconButton
                                    color="primary"
                                    sx={{ backgroundColor: 'primary.main', color: 'white' }}
                                    onClick={async () => {
                                        setOpenDialog(false);
                                        const { value: bagian } = await Swal.fire({
                                            title: 'Masukkan Bagian',
                                            input: 'text',
                                            inputLabel: 'Bagian',
                                            inputPlaceholder: 'Masukkan nama bagian',
                                            showCancelButton: true,
                                            confirmButtonText: 'Simpan',
                                            cancelButtonText: 'Batal'
                                        });
                                        if (bagian) {
                                            Swal.fire({
                                                title: 'Now loading',
                                                allowEscapeKey: false,
                                                allowOutsideClick: false,
                                                didOpen: () => {
                                                    Swal.showLoading();
                                                }
                                            });
                                            axios
                                                .post(apiUrl.apiUrl + '/sales/model/add-bagian', { bagian }, {
                                                    headers: { Authorization: `Bearer ${token}` }
                                                })
                                                .then(response => {
                                                    Swal.close();
                                                    if (response.data.success) {
                                                        Swal.fire({
                                                            title: 'Pemberitahuan',
                                                            text: response.data.message,
                                                            icon: 'success',
                                                            timer: 1000,
                                                            timerProgressBar: true
                                                        });
                                                        getListBagian();
                                                        setOpenDialog(true);
                                                    } else {
                                                        Swal.fire({
                                                            title: 'Pemberitahuan',
                                                            text: response.data.message,
                                                            icon: 'error'
                                                        });
                                                    }
                                                })
                                                .catch(error => {
                                                    Swal.close();
                                                    Swal.fire({
                                                        title: 'Pemberitahuan',
                                                        text: error.message,
                                                        icon: 'error'
                                                    });
                                                });
                                        }
                                    }}
                                >
                                    <Icon icon="mdi:plus" />
                                </IconButton>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <FormControl fullWidth>
                                    <InputLabel>Detail Bagian</InputLabel>
                                    <Controller
                                        name='detail_bagian'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Detail Bagian'
                                                value={value || ''}
                                                onChange={onChange}
                                                error={Boolean(errors.detail_bagian)}
                                            >
                                                {listBagianDetail.map((item: any, index: any) => (
                                                    <MenuItem value={item.nama} key={index}>
                                                        {item.nama}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.detail_bagian && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={1} sx={{ display: "flex", alignItems: "center" }}>
                                <IconButton
                                    color="primary"
                                    sx={{ backgroundColor: 'primary.main', color: 'white' }}
                                    onClick={async () => {
                                        if (getValues('bagian') == '' || getValues('bagian') == null) {
                                            alert("Bagian tidak boleh kosong");
                                            return;
                                        }
                                        setOpenDialog(false);
                                        const { value: bagianDetail } = await Swal.fire({
                                            title: 'Masukkan Detail Bagian',
                                            input: 'text',
                                            inputLabel: 'Detail Bagian',
                                            inputPlaceholder: 'Masukkan nama detail bagian',
                                            showCancelButton: true,
                                            confirmButtonText: 'Simpan',
                                            cancelButtonText: 'Batal'
                                        });
                                        if (bagianDetail) {
                                            Swal.fire({
                                                title: 'Now loading',
                                                allowEscapeKey: false,
                                                allowOutsideClick: false,
                                                didOpen: () => {
                                                    Swal.showLoading();
                                                }
                                            });
                                            const bagian = getValues('bagian');
                                            axios
                                                .post(apiUrl.apiUrl + `/sales/model/add-bagian-detail/${bagian}`, { bagian_detail: bagianDetail }, {
                                                    headers: { Authorization: `Bearer ${token}` }
                                                })
                                                .then(response => {
                                                    Swal.close();
                                                    if (response.data.success) {
                                                        Swal.fire({
                                                            title: 'Pemberitahuan',
                                                            text: response.data.message,
                                                            icon: 'success',
                                                            timer: 1000,
                                                            timerProgressBar: true
                                                        });
                                                        getListBagianDetail(bagian);
                                                        setOpenDialog(true);
                                                    } else {
                                                        Swal.fire({
                                                            title: 'Pemberitahuan',
                                                            text: response.data.message,
                                                            icon: 'error'
                                                        });
                                                    }
                                                })
                                                .catch(error => {
                                                    Swal.close();
                                                    Swal.fire({
                                                        title: 'Pemberitahuan',
                                                        text: error.message,
                                                        icon: 'error'
                                                    });
                                                });
                                        }
                                    }}
                                >
                                    <Icon icon="mdi:plus" />
                                </IconButton>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='jenis_barang_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valItem}
                                                options={listItem}
                                                id='jenis_barang_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteItem}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Item'
                                                        error={Boolean(errors.jenis_barang_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.jenis_barang_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            {
                                watch('is_kain') == 1 ?
                                    <>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                                <Controller
                                                    name='kebutuhan_bagian'
                                                    control={control}
                                                    rules={{ required: true }}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            label='Kebutuhan'
                                                            error={Boolean(errors.kebutuhan_bagian)}
                                                            onChange={onChange}
                                                            type='number'
                                                            value={value}
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                                {errors.kebutuhan_bagian && (
                                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <FormControl fullWidth>
                                                <Controller
                                                    name='panjang_bagian'
                                                    control={control}
                                                    rules={{ required: true }}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            label='Panjang'
                                                            error={Boolean(errors.panjang_bagian)}
                                                            onChange={onChange}
                                                            value={value}
                                                            type='number'
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                                {errors.panjang_bagian && (
                                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <FormControl fullWidth>
                                                <Controller
                                                    name='lebar_bagian'
                                                    control={control}
                                                    rules={{ required: true }}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            label='Lebar'
                                                            error={Boolean(errors.lebar_bagian)}
                                                            onChange={onChange}
                                                            value={value}
                                                            type='number'
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                                {errors.lebar_bagian && (
                                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <FormControl fullWidth>
                                                <Controller
                                                    name='lebihan_panjang_bagian'
                                                    control={control}
                                                    rules={{ required: true }}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            label='Lebihan Panjang'
                                                            error={Boolean(errors.lebihan_panjang_bagian)}
                                                            onChange={onChange}
                                                            value={value}
                                                            type='number'
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                                {errors.lebihan_panjang_bagian && (
                                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <FormControl fullWidth>
                                                <Controller
                                                    name='lebihan_lebar_bagian'
                                                    control={control}
                                                    rules={{ required: true }}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            label='Lebihan Lebar'
                                                            error={Boolean(errors.lebihan_lebar_bagian)}
                                                            onChange={onChange}
                                                            value={value}
                                                            type='number'
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                                {errors.lebihan_lebar_bagian && (
                                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                    </>
                                    :
                                    <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='qty_bagian'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Qty'
                                                        error={Boolean(errors.qty_bagian)}
                                                        onChange={onChange}
                                                        type='number'
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.qty_bagian && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                            }
                            <Grid item xs={12} sm={12}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, color: '#212121' }}>
                                    Pengaturan Perubahan Ukuran
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='is_berubah_panjang'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <FormControlLabel
                                                label='Jika Panjang Berubah ?'
                                                sx={{ fontWeight: 'bold', mb: 1, color: '#212121' }}
                                                control={
                                                    <Checkbox
                                                        checked={value || false}
                                                        onChange={(e) => {
                                                            onChange(e.target.checked);
                                                            if (e.target.checked) {
                                                                setValue('persen_lebih_panjang_panjang', 100);
                                                                setValue('persen_lebih_panjang_lebar', 100);
                                                            } else {
                                                                setValue('persen_lebih_panjang_panjang', null);
                                                                setValue('persen_lebih_panjang_lebar', null);
                                                            }
                                                        }}
                                                    />
                                                }
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            {watch('is_berubah_panjang') && (
                                <>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='persen_lebih_panjang_panjang'
                                                control={control}
                                                rules={{
                                                    required: watch('is_berubah_panjang'),
                                                    min: { value: 0, message: 'Minimal 0%' },
                                                    max: { value: 1000, message: 'Maksimal 1000%' }
                                                }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Persen Panjang (%)'
                                                        error={Boolean(errors.persen_lebih_panjang_panjang)}
                                                        onChange={onChange}
                                                        value={value || ''}
                                                        type='number'
                                                        inputProps={{ min: 0, max: 1000 }}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.persen_lebih_panjang_panjang && (
                                                <FormHelperText sx={{ color: 'error.main' }}>
                                                    {typeof errors.persen_lebih_panjang_panjang.message === 'string' ? errors.persen_lebih_panjang_panjang.message : 'Form ini tidak boleh kosong.'}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='persen_lebih_panjang_lebar'
                                                control={control}
                                                rules={{
                                                    required: watch('is_berubah_panjang'),
                                                    min: { value: 0, message: 'Minimal 0%' },
                                                    max: { value: 1000, message: 'Maksimal 100%' }
                                                }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Persen Lebar (%)'
                                                        error={Boolean(errors.persen_lebih_panjang_lebar)}
                                                        onChange={onChange}
                                                        value={value || ''}
                                                        type='number'
                                                        inputProps={{ min: 0, max: 1000 }}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.persen_lebih_panjang_lebar && (
                                                <FormHelperText sx={{ color: 'error.main' }}>
                                                    {typeof errors.persen_lebih_panjang_lebar.message === 'string' ? errors.persen_lebih_panjang_lebar.message : 'Form ini tidak boleh kosong.'}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={2}></Grid>
                                </>
                            )}
                            {watch('is_berubah_lebar') ? (
                                <Grid item xs={12} sm={12} sx={{ mt: -10 }}></Grid>
                            ) : null}
                            <Grid item xs={12} sm={2}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='is_berubah_lebar'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <FormControlLabel
                                                label='Jika Lebar Berubah ?'
                                                sx={{ fontWeight: 'bold', mb: 1, color: '#212121' }}
                                                control={
                                                    <Checkbox
                                                        checked={value || false}
                                                        onChange={(e) => {
                                                            onChange(e.target.checked);
                                                            if (e.target.checked) {
                                                                setValue('persen_lebih_lebar_panjang', 100);
                                                                setValue('persen_lebih_lebar_lebar', 100);
                                                            } else {
                                                                setValue('persen_lebih_lebar_panjang', null);
                                                                setValue('persen_lebih_lebar_lebar', null);
                                                            }
                                                        }}
                                                    />
                                                }
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            {watch('is_berubah_lebar') && (
                                <>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='persen_lebih_lebar_panjang'
                                                control={control}
                                                rules={{
                                                    required: watch('is_berubah_lebar'),
                                                    min: { value: 0, message: 'Minimal 0%' },
                                                    max: { value: 1000, message: 'Maksimal 100%' }
                                                }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Persen Panjang (%)'
                                                        error={Boolean(errors.persen_lebih_lebar_panjang)}
                                                        onChange={onChange}
                                                        value={value || ''}
                                                        type='number'
                                                        inputProps={{ min: 0, max: 1000 }}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.persen_lebih_lebar_panjang && (
                                                <FormHelperText sx={{ color: 'error.main' }}>
                                                    {typeof errors.persen_lebih_lebar_panjang.message === 'string' ? errors.persen_lebih_lebar_panjang.message : 'Form ini tidak boleh kosong.'}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='persen_lebih_lebar_lebar'
                                                control={control}
                                                rules={{
                                                    required: watch('is_berubah_lebar'),
                                                    min: { value: 0, message: 'Minimal 0%' },
                                                    max: { value: 1000, message: 'Maksimal 100%' }
                                                }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Persen Lebar (%)'
                                                        error={Boolean(errors.persen_lebih_lebar_lebar)}
                                                        onChange={onChange}
                                                        value={value || ''}
                                                        type='number'
                                                        inputProps={{ min: 0, max: 1000 }}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.persen_lebih_lebar_lebar && (
                                                <FormHelperText sx={{ color: 'error.main' }}>
                                                    {typeof errors.persen_lebih_lebar_lebar.message === 'string' ? errors.persen_lebih_lebar_lebar.message : 'Form ini tidak boleh kosong.'}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={2}></Grid>
                                </>)}
                            {watch('is_berubah_tinggi') ? (
                                <Grid item xs={12} sm={12} sx={{ mt: -10 }}></Grid>
                            ) : null}
                            <Grid item xs={12} sm={2}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='is_berubah_tinggi'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <FormControlLabel
                                                label='Jika Tinggi Berubah ?'
                                                sx={{ fontWeight: 'bold', mb: 1, color: '#212121' }}
                                                control={
                                                    <Checkbox
                                                        checked={value || false}
                                                        onChange={(e) => {
                                                            onChange(e.target.checked);
                                                            if (e.target.checked) {
                                                                setValue('persen_lebih_tinggi_panjang', 100);
                                                                setValue('persen_lebih_tinggi_lebar', 100);
                                                            } else {
                                                                setValue('persen_lebih_tinggi_panjang', null);
                                                                setValue('persen_lebih_tinggi_lebar', null);
                                                            }
                                                        }}
                                                    />
                                                }
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            {watch('is_berubah_tinggi') && (
                                <>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='persen_lebih_tinggi_panjang'
                                                control={control}
                                                rules={{
                                                    required: watch('is_berubah_tinggi'),
                                                    min: { value: 0, message: 'Minimal 0%' },
                                                    max: { value: 1000, message: 'Maksimal 100%' }
                                                }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Persen Panjang (%)'
                                                        error={Boolean(errors.persen_lebih_tinggi_panjang)}
                                                        onChange={onChange}
                                                        value={value || ''}
                                                        type='number'
                                                        inputProps={{ min: 0, max: 1000 }}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.persen_lebih_tinggi_panjang && (
                                                <FormHelperText sx={{ color: 'error.main' }}>
                                                    {typeof errors.persen_lebih_tinggi_panjang.message === 'string' ? errors.persen_lebih_tinggi_panjang.message : 'Form ini tidak boleh kosong.'}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='persen_lebih_tinggi_lebar'
                                                control={control}
                                                rules={{
                                                    required: watch('is_berubah_tinggi'),
                                                    min: { value: 0, message: 'Minimal 0%' },
                                                    max: { value: 1000, message: 'Maksimal 100%' }
                                                }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Persen Lebar (%)'
                                                        error={Boolean(errors.persen_lebih_tinggi_lebar)}
                                                        onChange={onChange}
                                                        value={value || ''}
                                                        type='number'
                                                        inputProps={{ min: 0, max: 1000 }}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.persen_lebih_tinggi_lebar && (
                                                <FormHelperText sx={{ color: 'error.main' }}>
                                                    {typeof errors.persen_lebih_tinggi_lebar.message === 'string' ? errors.persen_lebih_tinggi_lebar.message : 'Form ini tidak boleh kosong.'}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                </>
                            )}
                            {watch('is_biaya_produksi') ? (
                                <Grid item xs={12} sm={12} sx={{ mt: -10 }}></Grid>
                            ) : null}
                            <Grid item xs={12} sm={2}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='is_biaya_produksi'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <FormControlLabel
                                                label='Biaya Produksi ?'
                                                sx={{ fontWeight: 'bold', mb: 1, color: '#212121' }}
                                                control={
                                                    <Checkbox
                                                        checked={value || false}
                                                        onChange={(e) => {
                                                            onChange(e.target.checked);
                                                            if (e.target.checked) {
                                                                setValue('biaya_produksi', 0);
                                                            } else {
                                                                setValue('biaya_produksi', null);
                                                            }
                                                        }}
                                                    />
                                                }
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            {watch('is_biaya_produksi') && (
                                <>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='jasa_id'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <Autocomplete
                                                        value={valJasa}
                                                        options={listBarangJasa}
                                                        id='jasa_id'
                                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                        onChange={handleChangeAutocompleteJasa}
                                                        renderOption={(props: any, option: any) => {
                                                            return (
                                                                <li {...props} key={option.id}>
                                                                    {option.nama}
                                                                </li>
                                                            )
                                                        }}
                                                        getOptionLabel={(option: any) => option.nama}
                                                        renderInput={(params: any) => (
                                                            <TextField
                                                                {...params}
                                                                label='Item'
                                                                error={Boolean(errors.jenis_barang_id)}
                                                                InputLabelProps={{ shrink: true }}
                                                            />
                                                        )}
                                                    />
                                                )}
                                            />
                                            {errors.jenis_barang_id && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='biaya_produksi'
                                                control={control}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Biaya Produksi'
                                                        error={Boolean(errors.biaya_produksi)}
                                                        onChange={onChange}
                                                        value={value || ''}
                                                        type='text'
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{ readOnly: true }}
                                                    />
                                                )}
                                            />
                                            {errors.biaya_produksi && (
                                                <FormHelperText sx={{ color: 'error.main' }}>
                                                    {typeof errors.biaya_produksi.message === 'string' ? errors.biaya_produksi.message : 'Form ini tidak boleh kosong.'}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                </>
                            )}
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan_bagian'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Keterangan'
                                                multiline
                                                rows={2}
                                                error={Boolean(errors.keterangan_bagian)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan_bagian && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant="contained" color="primary" type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialogJasa}
                onClose={() => setOpenDialogJasa(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit(data => {
                    let formData = {
                        sdmodel_id: id,
                        sdmodel_d_id: getValues('sdmodel_d_id'),
                        jenis_barang_id: getValues('jasa_id'),
                        qty: getValues('qty_bagian'),
                        keterangan: getValues('keterangan_bagian')
                    }

                    let url = apiUrl.apiUrl + '/sales/model/add-jasa';
                    if (isEdit) {
                        url = apiUrl.apiUrl + '/sales/model/edit-jasa/' + getValues('sdmodel_d_id');
                    }
                    axios
                        .post(url, formData, {
                            headers: { Authorization: `Bearer ${token}` }
                        })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                getListData(tabs)
                                setOpenDialogJasa(false);
                            } else {
                                showToast(response.data.message, 'error');
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        })
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Tambah Jasa
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            {isEdit && (
                                <Grid item xs={12} sm={12}>
                                    <FormControl fullWidth>
                                        <Controller
                                            name='sdmodel_d_id'
                                            control={control}
                                            rules={{ required: true }}
                                            render={({ field: { value, onChange } }) => (
                                                <TextField
                                                    label='ID'
                                                    error={Boolean(errors.sdmodel_d_id)}
                                                    onChange={onChange}
                                                    type='number'
                                                    value={value}
                                                    InputLabelProps={{ shrink: true }}
                                                    InputProps={{ readOnly: true }}
                                                />
                                            )}
                                        />
                                        {errors.sdmodel_d_id && (
                                            <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid>
                            )}
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='jasa_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valJasa}
                                                options={listBarangJasa}
                                                id='jasa_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteJasa}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Item'
                                                        error={Boolean(errors.jenis_barang_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.jenis_barang_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='qty_bagian'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Qty'
                                                error={Boolean(errors.qty_bagian)}
                                                onChange={onChange}
                                                type='number'
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.qty_bagian && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='biaya_produksi'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Biaya Jasa'
                                                error={Boolean(errors.biaya_produksi)}
                                                onChange={onChange}
                                                value={value || ''}
                                                type='text'
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{ readOnly: true }}
                                            />
                                        )}
                                    />
                                    {errors.biaya_produksi && (
                                        <FormHelperText sx={{ color: 'error.main' }}>
                                            {typeof errors.biaya_produksi.message === 'string' ? errors.biaya_produksi.message : 'Form ini tidak boleh kosong.'}
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan_bagian'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Keterangan'
                                                multiline
                                                rows={2}
                                                error={Boolean(errors.keterangan_bagian)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan_bagian && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant="contained" color="primary" type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialogJasa(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </Grid >
    )
}
